import React, { Component } from 'react'

import { Container } from 'components/Layout'
import InternetForm from '../InternetForm'
import HeadingBanner from 'components/Text/HeadingBanner'

import sText from 'components/Text/Text.scss'

export default class InternetFormModal extends Component {
  render() {
    const { productName, modalConfirm, modalCancel } = this.props
    return (
      <div>
        <HeadingBanner filled>
          <h2 className={sText.heading3}>Signup for {productName}</h2>
          <div className={sText.descrip1}>This won't take much more than 5 minutes.</div>
        </HeadingBanner>
        <Container paddingTop paddingBottom className="sm">
          <InternetForm productName={productName} />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Internet/InternetFormModal/InternetFormModal.jsx